import { createSelector } from '@ngrx/store';

import { getWizzardMenuFlowPageByPageId } from '../getWizzardMenuFlowPageByPageId';

export const getWizzardMenuFlowPageSelectedProducts = (pageIdentifier: number) =>
    createSelector(getWizzardMenuFlowPageByPageId(pageIdentifier), (page) => page?.Products?.filter((p) => p.Quantity > 0).sort((a, b) => a.DisplayIndex - b.DisplayIndex) || null);
